module.exports = __webpack_public_path__ + "img/cuarto menguante.a847140b.svg";